import React from "react";
import MultiBadgeSelector from "./MultiBadgeSelector";
import { useFormikContext } from "formik";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
const Template = (props) => {
  const { onChange, value } = props;
  const { values } = useFormikContext();
  const { fieldsInfo } = values;

  const _onChange = (e) => {
    if (onChange) {
      onChange(`${value} {${e}}`);
    }
  };

  return (
    <div className="bg-white !px-4 !py-2 rounded-lg">
      <div className="flex items-center gap-2 my-2">
        <div className="text-xl font-bold text-gray-600">Plantillas</div>
      </div>
      <Alert variant="secondary" className="Notice">
        Selecciona las plantillas que deseas utilizar en la campaña
      </Alert>
      <div className="grid grid-cols-1 gap-4">
        <MultiBadgeSelector onChange={_onChange} fieldsInfo={fieldsInfo} />
      </div>
    </div>
  );
};

Template.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
};
export default Template;
